/**
 * LA COTIZACIÓN ENTREGADA, EN EL INBOX (3-nov-2026, F). El hecho lo escribe el webhook de estados en el chat
 * (`cotizacionEnviada: { en, clave, nombreArchivo, mensajeId }`) cuando Meta confirma la entrega de un archivo marcado
 * como cotización, y el turno anota `respondidaEn` con la primera respuesta del cliente posterior
 * (`functions/bot/media/archivoDeCotizacion.js`). Los filtros trabajan en memoria, como los demás del panel.
 *
 * CommonJS, como `botonesDeMensaje.js`, para que su test corra en la puerta de `functions/`.
 */

const aMs = (t) => {
  if (t == null) return NaN;
  if (typeof t === 'number') return t;
  if (t instanceof Date) return t.getTime();
  if (typeof t.toMillis === 'function') return t.toMillis();
  if (typeof t.seconds === 'number') return t.seconds * 1000;
  if (typeof t._seconds === 'number') return t._seconds * 1000;
  return NaN;
};

/** ¿Se le entregó una cotización a este chat? */
function tieneCotizacionEnviada(chat) {
  return Number.isFinite(aMs(chat?.cotizacionEnviada?.en));
}

/** ¿Se le entregó una cotización y el cliente no escribió después? */
function cotizacionSinRespuesta(chat) {
  return tieneCotizacionEnviada(chat) && !chat.cotizacionEnviada.respondidaEn;
}

/** La fecha de la entrega, para la etiqueta «Cotización enviada · fecha» (dd/mm en la zona del navegador), o null. */
function fechaDeCotizacion(chat) {
  const ms = aMs(chat?.cotizacionEnviada?.en);
  if (!Number.isFinite(ms)) return null;
  const f = new Date(ms);
  return `${String(f.getDate()).padStart(2, '0')}/${String(f.getMonth() + 1).padStart(2, '0')}`;
}

module.exports = { tieneCotizacionEnviada, cotizacionSinRespuesta, fechaDeCotizacion };
